import { createApp } from 'vue'
import ShipmentBoxFilters from '../../components/shipment-boxes/filters.vue'
import i18nPlugin, { i18n, loadTranslations } from '../../i18n'
import $bus from '../../../packs/event'

$.onmount('[data-vue=shipment-box-filters]', function () {
  const initialData = JSON.parse(this.attributes['data-initial-data'].value)
  const app = createApp(ShipmentBoxFilters, { initialData })
  app.use(i18nPlugin)
  app.config.globalProperties.$bus = $bus;

  loadTranslations(i18n).then(() => {
    app.mount(this)
  })
})
